module.exports = __webpack_public_path__ + "img/appAsset-bankingLogo__chile.d3c0b8d6.svg";